import { TSliderProps } from '@r1-frontend/ui-react/components/NukaCarousel/SliderHoc/types';

/**
 * Медиавыражения для определения соответствия документа определенному разрешению (Исп-ся для смены контейнера карточек на слайдер)
 *
 * @name constants.EMediaWidth
 * @type {enum}
 */
export enum EMediaWidth {
    desktop = '(min-width: 1601px)',
    sDesktop = '(max-width: 1600px) and (min-width: 1280px)',
    laptop = '(max-width: 1279px) and (min-width: 768px)',
    sLaptop = '(max-width: 1024px)',
    mobile = '(max-width: 767px)',
}

/**
 * Первоначальный стейт maxCardsData
 *
 * @name constants.DEFAULT_STATE_MAX_CARDS
 * @type {TSliderProps}
 */
export const DEFAULT_STATE_MAX_CARDS: TSliderProps = { value: 1, gap: 40 };

/**
 * Данные для слайдера в соответсвии разрешению (value - макс кол-во карточек без переполнения, gap - расстояние между слайдами)
 *
 * Страница /promo
 *
 * @name constants.DATA_SLIDER_PARAMS_DEFAULT
 * @type { Record<string, TSliderProps>}
 */
export const DATA_SLIDER_PARAMS_DEFAULT: Record<string, TSliderProps> = {
    mobile: { value: 1, gap: 35 },
    laptop: { value: 2, gap: 66 },
    sDesktop: { value: 3, gap: 96 },
    desktop: { value: 4, gap: 129 },
};

/**
 * Ширина карточки для слайдера
 *
 * @name constants.CARD_WIDTH
 * @type {string}
 */
export const CARD_WIDTH = '316px';
